import moment from 'moment';

/**
 * Shared logic between Overview and Admin Dashboard
 */
export default {
  methods: {
    async changeCurrentCompany(event, companyId, path) {
      event && event.preventDefault && event.preventDefault();

      await this.$store.dispatch('resetTiles', { companyId });
      this.$router.push(path);
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    oneWeekAway(date) {
      return moment().add(6, 'days') >= moment(date);
    },
    pastDue(date) {
      return moment() > moment(date);
    },
    truncateString(str, num) {
      if (str.length <= num) {
        return str;
      }
      return str.slice(0, num) + '...';
    },
    getNextReminderDate(parentQuestionnaire, remainingItems, currentUserFirm) {
      if (this.pastDue(parentQuestionnaire.due_date)) {
        return 'Due date is already passed';
      }

      if (parentQuestionnaire.locked) {
        return 'We will not send an automatic reminder since it is locked';
      }

      if (parentQuestionnaire.reminders_disabled) {
        return 'Reminders are disabled';
      }
      const questionnaire = remainingItems
        ? remainingItems
        : parentQuestionnaire;
      const baseDate = moment(
        questionnaire.last_followed_up
          ? questionnaire.last_followed_up
          : questionnaire.sent_at,
      );
      const numToAdd = currentUserFirm.questionnaire_reminder_frequency;
      const new_date = baseDate.add(numToAdd, 'day');
      const reminderDate = this.getReminderDate(new_date);
      const momentDueDate = moment(questionnaire.due_date, 'YYYY-MM-DD');
      const earliestReminderMoment = moment(
        questionnaire.earliest_remind_date,
        'YYYY-MM-DD',
      );

      if (
        (!questionnaire.earliest_remind_date ||
          (questionnaire.earliest_remind_date &&
            earliestReminderMoment.isBefore(reminderDate))) &&
        reminderDate.isBefore(momentDueDate)
      ) {
        return `Reminder is set to go out on ${moment(
          reminderDate.toISOString(),
          moment.ISO_8601,
        ).format('ll')}.`; //Normal, without earliest reminder date
      } else if (
        questionnaire.earliest_remind_date &&
        (earliestReminderMoment.isAfter(reminderDate) ||
          earliestReminderMoment.isSame(reminderDate)) &&
        earliestReminderMoment.isBefore(momentDueDate)
      ) {
        return `Reminder is set to go out on ${moment(
          earliestReminderMoment.toISOString(),
          moment.ISO_8601,
        ).format('ll')} because of client estimated completion date.`; //earliest reminder date is later than next reminder date
      } else if (
        questionnaire.earliest_remind_date &&
        earliestReminderMoment.isAfter(reminderDate) &&
        earliestReminderMoment.isAfter(momentDueDate) &&
        momentDueDate
          .clone()
          .subtract(3, 'days')
          .isAfter(moment().startOf('day'))
      ) {
        return `Reminder is set to go out 3 days before due date (${moment(
          momentDueDate
            .clone()
            .subtract(3, 'days')
            .toISOString(),
          moment.ISO_8601,
        ).format('ll')}).`; //earliest reminder date is later than due date
      } else if (
        !reminderDate.isBefore(momentDueDate) &&
        !reminderDate.isSame(momentDueDate)
      ) {
        return `We will not send an automatic reminder since the reminder date is past the due date.`;
      }
    },

    // NOTE @chris This is the same logic as above, but without the extra strings and fallbacks. We should merge them together in a separate scope.
    getNextReminderDateString(parentQuestionnaire, currentUserFirm) {
      if (
        this.pastDue(parentQuestionnaire.due_date) ||
        parentQuestionnaire.locked ||
        parentQuestionnaire.reminders_disabled ||
        parentQuestionnaire.completed
      )
        return null;

      const questionnaire = parentQuestionnaire;
      const baseDate = moment(
        questionnaire.last_followed_up
          ? questionnaire.last_followed_up
          : questionnaire.sent_at,
      );
      const numToAdd = currentUserFirm.questionnaire_reminder_frequency;
      const newDate = baseDate.add(numToAdd, 'day');
      const reminderDate = this.getReminderDate(newDate);
      const momentDueDate = moment(parentQuestionnaire.due_date, 'YYYY-MM-DD');
      const earliestReminderMoment = moment(
        parentQuestionnaire.earliest_remind_date,
        'YYYY-MM-DD',
      );

      if (
        (!parentQuestionnaire.earliest_remind_date ||
          (parentQuestionnaire.earliest_remind_date &&
            earliestReminderMoment.isBefore(reminderDate))) &&
        reminderDate.isBefore(momentDueDate)
      ) {
        return moment(reminderDate.toISOString(), moment.ISO_8601).format('ll');
      } else if (
        parentQuestionnaire.earliest_remind_date &&
        (earliestReminderMoment.isAfter(reminderDate) ||
          earliestReminderMoment.isSame(reminderDate)) &&
        earliestReminderMoment.isBefore(momentDueDate)
      ) {
        return moment(
          earliestReminderMoment.toISOString(),
          moment.ISO_8601,
        ).format('ll');
      } else if (
        parentQuestionnaire.earliest_remind_date &&
        earliestReminderMoment.isAfter(reminderDate) &&
        earliestReminderMoment.isAfter(momentDueDate) &&
        momentDueDate
          .clone()
          .subtract(3, 'days')
          .isAfter(moment().startOf('day'))
      ) {
        return moment(
          momentDueDate
            .clone()
            .subtract(3, 'days')
            .toISOString(),
          moment.ISO_8601,
        ).format('ll');
      }

      return null;
    },
    getReminderDate(newDate) {
      return newDate.isBefore(moment())
        ? moment()
            .utc()
            .hours() < 10
          ? moment()
          : moment().add(1, 'days')
        : newDate.startOf('day');
    },
  },
  computed: {
    isSorabanAdmin() {
      return this.currentUser.email.toLowerCase().includes('@soraban.com');
    },
  },
};
